export const UPLOAD_JOB_DESCRIPTION = "UPLOAD_JOB_DESCRIPTION";
export const CLEAR_JOB_FORM_STATE = "CLEAR_JOB_FORM_STATE";
export const SET_FIELDS_TO_DISPLAY_CHANGES_SAVED_MARKER =
  "SET_FIELDS_TO_DISPLAY_CHANGES_SAVED_MARKER";
